import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../services/ProfileService";
import PPIService from "../../services/PPIService";
import Modal from "react-modal";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

Modal.setAppElement("#root"); // Set this once at app root level

const MinKyc = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");

  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [consentOpen, setConsentOpen] = useState(false);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidIndianMobile = (mobile) => /^[6-9]\d{9}$/.test(mobile);

  const generateOtpHandler = async () => {
    if (!name.trim())
      return Swal.fire("Oops!", "Please enter your name.", "error");
    if (!mobile.trim())
      return Swal.fire("Oops!", "Please enter your mobile number.", "error");
    if (!isValidIndianMobile(mobile)) {
      return Swal.fire(
        "Oops!",
        "Please enter a valid 10-digit Indian mobile number.",
        "error"
      );
    }
    if (!email.trim())
      return Swal.fire("Oops!", "Please enter your email.", "error");
    if (!isValidEmail(email)) {
      return Swal.fire("Oops!", "Please enter a valid email address.", "error");
    }
    if (!checked1 || !checked2 || !checked3) {
      return Swal.fire("Oops!", "Please accept all declarations.", "error");
    }

    setLoading(true);
    try {
      const result = await PPIService.minKycGenerateOtp(name, mobile, email);
      if (!result.success) {
        return Swal.fire(
          "Oops!",
          result.message || "Failed to generate OTP",
          "error"
        );
      }

      const responseData = result.data;

      // DIRECT CARD ISSUANCE
      if (
        responseData.status == "SUCCESS" &&
        responseData.message == "CARD_ISSUANCE"
      ) {
        navigate("/issue-digital-card", {
          state: {},
        });
        return;
      }

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;

        const message = responseData.message;
        const verificationToken = data.verification_token;

        // Redirect with token and message
        navigate("/min-kyc/verify-otp", {
          state: {
            verificationToken,
            message,
          },
        });

        // Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const [profileData, setProfileData] = useState();

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const result = await ProfileService.fetch();
      if (!result.success) {
        return Swal.fire("Oops!", result.message || "Failed to fetch", "error");
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        const data = responseData.data;

        setProfileData(data);
        setMobile(data.mobile);
        setName(data.name);
        setEmail(data.email);

        // Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Header />

      <div className=" px-3  d-flex align-items-center justify-content-center">
        <div className="card rounded-4 w-100" style={{ maxWidth: "1200px" }}>
          <div className="card-body p-4">
            <h4 className="mb-4 text-center">PPI User Onboarding | Min KYC</h4>

            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your full name"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Mobile Number</label>
              <input
                type="text"
                className="form-control"
                value={profileData ? profileData.mobile : ""}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Enter 10-digit mobile number"
                maxLength="10"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
              />
            </div>

            {/* Declaration Section */}
            <div className="mb-3">
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check1"
                  checked={checked1}
                  onChange={() => setChecked1(!checked1)}
                />
                <label className="form-check-label" htmlFor="check1">
                  I confirm to have read the program{" "}
                  <a
                    href="https://www.formaxpay.com/ppi_tnc"
                    target="_blank"
                    rel="noreferrer"
                  >
                    T&Cs
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://www.pineperks.in/privacyPolicy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                  .
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check2"
                  checked={checked2}
                  onChange={() => setChecked2(!checked2)}
                />
                <label className="form-check-label" htmlFor="check2">
                  I declare that I am not a politically exposed person (PEP).
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check3"
                  checked={checked3}
                  onChange={() => setChecked3(!checked3)}
                />
                <label className="form-check-label" htmlFor="check3">
                  I provide my{" "}
                  <span
                    className="text-primary"
                    role="button"
                    onClick={() => setConsentOpen(true)}
                  >
                    consent
                  </span>{" "}
                  to Pine Labs to complete my KYC for the purpose of opening my
                  PPI account.
                </label>
              </div>
            </div>

            <button
              className="btn btn-primary w-100"
              onClick={generateOtpHandler}
              disabled={loading}
            >
              {loading ? "Processing..." : "Generate OTP"}
            </button>

            <div className="pt-3"></div>
            {/* Powered By */}
            <hr />
            <div className="text-center">
              <small className="text-muted d-block mb-1">ISSUED BY</small>
              <img
                src="/images/pine-labs-logo.png"
                alt="Pine Labs"
                style={{ height: "22px" }}
              />
            </div>
          </div>
        </div>

        {/* Consent Modal */}
        <Modal
          isOpen={consentOpen}
          onRequestClose={() => setConsentOpen(false)}
          contentLabel="Consent Dialog"
          style={{
            content: {
              maxWidth: "500px",
              margin: "auto",
              borderRadius: "12px",
              padding: "20px",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            },
          }}
        >
          <h5>Consent Information</h5>
          <p>
            By proceeding further, I agree to Formax It Solutions Private
            Limited sharing my personal information (Name (First Name, Last
            Name); Mobile Number; Email ID) with Pine Labs in connection with a
            Pine Labs PPI. I,further agree that Pine Labs or its contractors may
            hold and process my Personal Information for a period of 10 years as
            prescribed by RBI guidelines and I have no objection thereto. I have
            read and understood the terms and conditions and privacy policy for
            the Formax Pay – PPI issued by Pine Labs Private Limited (Pine
            Labs). I agree to abide by these terms and conditions and privacy
            policy, as updated from time to time.
          </p>
          <button
            className="btn btn-secondary mt-3"
            onClick={() => setConsentOpen(false)}
          >
            Close
          </button>
        </Modal>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default MinKyc;
